/**
 * KeyboardIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const KeyboardIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M5.862 8.999a.9.9 0 0 1 1.292 0 .944.944 0 0 1 0 1.316.9.9 0 0 1-.61.306.9.9 0 0 1-.345-.074.83.83 0 0 1-.491-.5 1 1 0 0 1-.073-.353A.94.94 0 0 1 5.862 9m.255 4.326a.95.95 0 0 1 1.026.195.92.92 0 0 1 .005 1.314l-.005.006a.94.94 0 0 1-.631.306 1 1 0 0 1-.358-.074.9.9 0 0 1-.31-.195.92.92 0 0 1-.038-1.357.9.9 0 0 1 .31-.196m3.326-4.329A.904.904 0 0 1 10.735 9a.94.94 0 0 1-.005 1.314.9.9 0 0 1-.639.269l.037.037a.9.9 0 0 1-.347-.074 1 1 0 0 1-.302-.195.9.9 0 0 1-.192-.307 1 1 0 0 1-.073-.353.94.94 0 0 1 .228-.696m3.985-.195a.9.9 0 0 1 .993.194.94.94 0 0 1 .191 1.014.9.9 0 0 1-.191.306.95.95 0 0 1-.61.307.9.9 0 0 1-.347-.074 1 1 0 0 1-.3-.196.9.9 0 0 1-.192-.306 1 1 0 0 1-.073-.353.94.94 0 0 1 .228-.698q.133-.122.3-.195m3.424.214a.963.963 0 0 1 1.351-.019.92.92 0 0 1 .273.66.9.9 0 0 1-.076.354.84.84 0 0 1-.506.502 1 1 0 0 1-.357.111.94.94 0 0 1-.667-.27.94.94 0 0 1-.018-1.338m.246 4.313a.91.91 0 0 1 1 .195c.36.361.363.95.006 1.314a.9.9 0 0 1-.657.275l.037.037a.9.9 0 0 1-.349-.074.9.9 0 0 1-.303-.195l-.11-.14a.7.7 0 0 1-.082-.167.6.6 0 0 1-.056-.167 1 1 0 0 1 0-.186 1 1 0 0 1 .212-.697.9.9 0 0 1 .302-.196m-6.868.033h3.65c.503 0 .912.4.912.895a.904.904 0 0 1-.913.894h-3.649a.904.904 0 0 1-.912-.894c0-.494.408-.895.912-.895" />
    <path
      fillRule="evenodd"
      d="M3.75 4.2h16.5A2.75 2.75 0 0 1 23 6.95v10.08a2.75 2.75 0 0 1-2.75 2.749H3.75A2.75 2.75 0 0 1 1 17.029V6.95A2.75 2.75 0 0 1 3.75 4.2m16.5 13.746c.506 0 .917-.41.917-.916V6.95a.917.917 0 0 0-.917-.917H3.75a.917.917 0 0 0-.917.916v10.08c0 .506.411.917.917.917z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const KeyboardIcon = makeIcon('KeyboardIcon', KeyboardIconSvg)
